import clsx from 'clsx';
import { useMemo } from 'react';

import { useQueryState } from '@/hooks/useQueryState';
import { useTradeStore } from '@/store/trade-store';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';
import HistoryOrders from './history-orders/history-orders';
import PositionOrders from './position-orders/position-orders';
import { PanelType } from './type';

type StateQuery = {
    tab: PanelType;
};

const currentState = {
    tab: PanelType.Position,
};

export function TradingPanelOrder() {
    const { t } = useTranslation();

    const { state, setQueryState } = useQueryState<StateQuery>(currentState);

    const { count } = useTradeStore(
        useShallow((state) => ({
            count: state.count,
        }))
    );

    const tabs = useMemo(() => {
        return [
            {
                title: 'Positions',
                value: PanelType.Position,
                component: <PositionOrders />,
                numbers: count.openTrade,
            },

            {
                title: 'History',
                value: PanelType.History,
                component: <HistoryOrders />,
                numbers: 0,
            },
        ].filter(Boolean);
    }, [count.openTrade]);

    return (
        <div className="relative">
            <div className="flex items-center gap-3 overflow-auto no-scrollbar">
                {tabs.map((item) => {
                    return (
                        <button
                            key={item.value}
                            onClick={() => {
                                setQueryState({ tab: item.value });
                            }}
                            className={clsx(
                                'relative px-2 py-3 transition-all'
                            )}
                        >
                            <span
                                className={clsx(
                                    'text-xl text-[#666666] whitespace-nowrap',
                                    {
                                        '!text-white': state.tab === item.value,
                                    }
                                )}
                            >
                                {t(item.title)}{' '}
                                {item.numbers !== 0 ? ` (${item.numbers})` : ''}
                            </span>
                        </button>
                    );
                })}
            </div>

            {tabs.find((item) => item?.value === state.tab)?.component}
        </div>
    );
}
